import React from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

interface ExportLoadingBackdropProps {
  open: boolean;
  title: string;
  subtitle?: string;
}

export const ExportLoadingBackdrop: React.FC<ExportLoadingBackdropProps> = ({
  open,
  title,
  subtitle,
}) => {
  return (
    <Backdrop
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 2,
        backgroundColor: "rgba(0, 0, 0, 0.7)",
        ml: "0 !important",
      }}
      open={open}
    >
      <Stack alignItems="center" spacing={3}>
        <CircularProgress size={56} />
        <Stack alignItems="center" spacing={1} sx={{ maxWidth: 400, px: 3 }}>
          <Typography
            variant="h6"
            sx={{
              color: "#fff",
              fontWeight: 500,
              textAlign: "center",
              textShadow: "0 2px 4px rgba(0,0,0,0.3)",
            }}
          >
            {title}
          </Typography>
          {subtitle && (
            <Typography
              variant="body2"
              sx={{
                color: "rgba(255, 255, 255, 0.9)",
                textAlign: "center",
                textShadow: "0 1px 3px rgba(0,0,0,0.3)",
              }}
            >
              {subtitle}
            </Typography>
          )}
        </Stack>
      </Stack>
    </Backdrop>
  );
};
